import { Environment } from './environment.interface';
import { Constants } from './version';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment: Environment = {
	version: Constants.version,
	production: false,
	nativeAppLinkHost: 'dev.portal.labs.nova-a.de',
	firebase: {
		apiKey: 'AIzaSyArh2ohocokPMD8TVvIApCQ9T_I9qMZb34',
		authDomain: 'signin.dev.portal.labs.nova-a.de', //'novaa-portal-dev.firebaseapp.com'
		projectId: 'novaa-portal-dev',
		storageBucket: 'novaa-portal-dev.firebasestorage.app',
		messagingSenderId: '895355669923',
		appId: '1:895355669923:web:184f934f461dd89d7dde16'
	},
	picturesStorageBucket: 'novaa-portal-dev-pictures',
	featureToggles: {},
	// Enable client side logging
	clientLogEnabled: true,
	// Use local emulator for authentication (must be started before)
	useAuthEmulator: false,
	// Use local emulator for database (must be started before)
	useDBEmulator: false,
	// Use local emulator for storage (must be started before)
	useStorageEmulator: false,
	// Use local emulator for functions (must be started before)
	useFunctionsEmulator: false,
	// Use mock data instead of accessing the real database
	useMockData: false,
	// Override system settings to force the theme mode to 'light' or 'dark'
	forceThemeMode: null,
	// Add an extra top padding for the device status bar / notch
	forceStatusbarPadding: false
};
